import { Box, makeStyles, Typography, withStyles } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { chatInstance } from "api/globalaxios";
import { containerContext } from "features/Chat/ChatContainer";
import { useDebouncedValue } from "hooks";
import React, { Fragment, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAnchorMessage } from "slices/chatSlice";
import { scrollToMessage } from "utils/chatUtils";

const CssTextField = withStyles({
  root: {
    padding: "0",
    "& MuiSvgIcon-root": {
      color: "red",
    },
    "& label.Mui-focused": {
      color: "transparent",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "transparent",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0rem",

      paddingRight: "4rem !important",
      paddingLeft: "1rem !important",
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  input: {
    "&::placeholder": {
      color: theme.palette.common.grey1,
      opacity: "1",
      lineHeight: "1.75",
    },
    padding: "1rem 0 !important",
  },
}));

const Search = ({ setStep, smallScreen }) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [input, setInput] = React.useState("");
  const loading = open && options.length === 0;
  const debouncedInput = useDebouncedValue(input, 500);
  const activeGroup = useSelector((state) => state.groups.activeGroup);
  const { messageContainer } = useContext(containerContext);
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChange = (event) => {
    const input = event.target.value;
    setInput(input);
    setOptions([]);
  };

  const getOptionSelected = (option, value) => {
    return option._id == value._id;
  };

  const removeAnchorMessage = () => {
    dispatch(setAnchorMessage(null));
  };

  const onChange = (event, value) => {
    setStep(1);

    if (value) {
      !smallScreen
        ? scrollToMessage(messageContainer, value._id, removeAnchorMessage)
        : dispatch(setAnchorMessage(value._id));

      // dispatch(setAnchorMessage(value._id));
    }
  };

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      let response = await chatInstance({
        method: "get",
        url: "/api/v1/chat.search",
        params: {
          roomId: activeGroup,
          searchText: input,
          count: 5,
        },
      });
      let {
        data: { messages },
      } = response;
      if (active) {
        setOptions(messages);
      }
    })();

    return () => {
      active = false;
    };
  }, [debouncedInput]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);
  return (
    <Autocomplete
      id="message-search"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onChange={onChange}
      onInputChange={handleChange}
      onClose={() => {
        setOpen(false);
      }}
      style={{margin: '10px', background: '#fff', border: 'border: 1px solid #E2E8F0' }}
      filterOptions={(x) => x}
      includeInputInList
      getOptionSelected={getOptionSelected}
      getOptionLabel={(option) => {
        return (
          <Fragment>
            {option.msg}
            <Box display="inline-block" width="1rem"></Box>
            <Typography variant="caption">by {option.u.name}</Typography>
          </Fragment>
        );
      }}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <CssTextField
          {...params}
          fullWidth
          variant="outlined"
          placeholder="Search in Conversation"
          InputProps={{
            ...params.InputProps,
            classes: { input: classes.input },

            startAdornment: (
              <React.Fragment>
                <SearchOutlinedIcon style={{ color: "#707C97" }} />
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default Search;
